/* eslint-disable quotes */
import { useState } from 'react';
import DragDropFile from '../../../components/DragDropFile/DragDropFile';
import { useStore } from '../../../core/utils/hook';
import '../style.scss';
import { MSG, SHARE_KNOWLEDGE_FILE_TYPE } from '../../../core/configs/constants';
import { extractFileNameAndExt, formatBytes } from '../../../core/utils/common';
import { IconUploadForm } from './Icon';
import Modal from 'react-modal';

const getFileExtension = (fileName) => {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

const THUMBNAIL_TYPE = 2;

const VIDEO_MAX_SIZE = 10 * 1024 * 1024 * 1024; // 10GB
const THUMBNAIL_MAX_SIZE = 10 * 1024 * 1024; // 10MB

const handleValidateFile = (file, accept) => {
    const acceptList = accept
        .split(',')
        .map((type) => type.trim().toLowerCase());

    const fileExt = '.' + file.name.split('.').pop().toLowerCase();

    return acceptList.includes(fileExt);
};

const ModalUploadVideo = (props) => {
    // store
    const {
        modalStore: { hide, show },
        userStore: { userInfoHeader },
        fileStore: { uploadFile },
        shareKnowledgeStore: { getPresignedUrls, createFile }
    } = useStore();
    const [video, setVideo] = useState(null);
    const [thumbnail, setThumbnail] = useState(null);
    const [videoDuration, setVideoDuration] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isShowProgressUpload, setIsShowProgressUpload] = useState(false);

    const handleUploadFile = async (fileUploadList, uploadSuccessCallback) => {
        setIsShowProgressUpload(true);
        const uploadPromises = fileUploadList.map((fileUpload) => {
            const fields = fileUpload?.fields;
            const { bucket, ...payload } = fields;
            const data = {
                ...(payload || {}),
                file: fileUpload.file
            };

            return new Promise((resolve, reject) => {
                uploadFile(fileUpload.presignedUrl, data, {
                    onSuccess: () => {
                        setIsShowProgressUpload(false);
                        resolve(true);
                    },
                    onError: () => {
                        setIsShowProgressUpload(false);
                        reject(false);
                    },
                    onUploadProgress: (progress) => setProgress(progress)
                }, false);
            });
        });

        try {
            const results = await Promise.all(uploadPromises);

            const allSuccessful = results.every((result) => result === true);

            if (allSuccessful) {
                uploadSuccessCallback();
            }
        } catch (error) {
            console.error('Error during file upload:', error);
        }
    };

    const onChangeFile = (file) => {
        if (!file) {
            setVideo(null);
            setVideoDuration(null);
            return;
        }
        if (file.name === video?.file?.name) return;
        const isErr = file.size > VIDEO_MAX_SIZE;
        setVideo({ file, isErr });

        const url = URL.createObjectURL(file);
        const el = document.createElement('video');
        el.preload = 'metadata';
        el.onloadedmetadata = () => { URL.revokeObjectURL(url); setVideoDuration(Math.floor(el.duration)); };
        el.onerror = () => { URL.revokeObjectURL(url); setVideoDuration(null); };
        el.src = url;
    };

    const handleChangeThumbnail = (file) => {
        if (!file) return setThumbnail(null);
        const isErr = file.size > THUMBNAIL_MAX_SIZE;
        setThumbnail({
            file,
            isErr
        });
    };

    const onSubmit = async () => {
        const groupId = userInfoHeader?.groupId;

        const files = [
            {
                name: video?.file?.name,
                size: video?.file?.size,
                type: video?.file?.type
            }
        ];

        const videoSignedList = await getPresignedUrls({
            groupId,
            files,
            type: SHARE_KNOWLEDGE_FILE_TYPE.VIDEO
        });

        if (!videoSignedList || videoSignedList?.length === 0) return;
        const [videoSigned] = videoSignedList;
        const uploadParams = [];
        uploadParams.push({
            file: video.file,
            presignedUrl: videoSigned.url,
            fields: videoSigned.fields
        });

        await handleUploadFile(uploadParams, async () => {
            const result = {
                name: videoSigned.name,
                location: videoSigned.location,
                type: SHARE_KNOWLEDGE_FILE_TYPE.VIDEO,
                groupId,
                size: video.file.size,
                thumbnail: null,
                code: videoSigned.code,
                duration: videoDuration
            };

            if (thumbnail) {
                const [thumbnailPresigned] = await getPresignedUrls({
                    groupId,
                    files: [
                        {
                            name: thumbnail?.file?.name,
                            type: thumbnail?.file?.type
                        }
                    ],
                    type: THUMBNAIL_TYPE
                });
                await handleUploadFile(
                    [
                        {
                            file: thumbnail.file,
                            presignedUrl: thumbnailPresigned.url,
                            fields: thumbnailPresigned.fields
                        }
                    ],
                    () => {
                        result.thumbnail = thumbnailPresigned.fields.key;
                    }
                );
            }
            const res = await createFile({ data: [result], type: SHARE_KNOWLEDGE_FILE_TYPE.VIDEO, groupId });
            if (res) {
                handleUploadSuccess();
            }
        });
    };

    const handleUploadSuccess = async () => {
        hide();
        props.onUploadSuccess();
    };

    return (
        <>
            <div className="share-knowledge-modal-upload-video">
                <div className="modal-body">
                    <div className="modal-content">
                        {video ? (
                            <>
                                <div
                                    className={`file-selected ${
                                        !video.isErr ? 'border-green' : 'border-red'
                                    } mg-b-10`}
                                >
                                    {video.isErr ? (
                                        <></>
                                    ) : (
                                        <div className="file-normally">
                                            <p>
                                                <img
                                                    src="/images/video_size_bypass.png"
                                                    className=""
                                                />
                                            </p>
                                            <p>アップロード成功</p>
                                        </div>
                                    )}
                                    <div className="flex gap-10 item-center item-box">
                                        <div className="icon-video flex-none">
                                            <img
                                                src="/images/u266.svg"
                                                className=""
                                            />
                                        </div>
                                        <div>
                                            <p className="flex justify-center text-14 file-name" style={{fontWeight: 700}}>
                                                <p
                                                    className="truncate"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="bottom"
                                                    title={video.file.name}
                                                    style={{ wordBreak: 'break-all' }}
                                                >
                                                    {extractFileNameAndExt(video.file.name).name}
                                                </p>
                                                <span>
                                                .
                                                    {getFileExtension(
                                                        video.file.name
                                                    )}
                                                </span>
                                            </p>
                                            <p className="file-size text-12">
                                                {formatBytes(video.file.size)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                        <DragDropFile
                            dragText="ここにファイルをドラッグ＆ドロップまたはファイルを選択する"
                            onChange={onChangeFile}
                            className={'upload-file-zone'}
                            uploadIcon={<div className='mg-b-10'>{IconUploadForm()}</div>}
                            accept=".mp4"
                            description={`1ファイルのみアップロード可能。対応フォーマット: .MP4、最大容量: ${formatBytes(
                                VIDEO_MAX_SIZE
                            )}`}
                            errorAccept="error.invalid_video"
                            maxSize={VIDEO_MAX_SIZE / 1024 / 1024}
                            errorMaxSize={`ファイルのアップロードに失敗しました。ファイルサイズが上限の${formatBytes(
                                VIDEO_MAX_SIZE
                            )}を超えています。再度お試しください。`}
                        />

                        <div className="thumb text-14 flex flex-gap-10">
                        サムネイル画像{' '}
                            <label className="btn btn-select-thumb">
                            ファイルを選択
                                <input
                                    type="file"
                                    accept=".jpg,.png"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        handleValidateFile(file, '.jpg,.png') &&
                                        handleChangeThumbnail(file);
                                        e.target.value = null;
                                    }}
                                    style={{ display: 'none' }}
                                />
                            </label>
                            {thumbnail && (
                                <div className="flex justify-content-center align-items-center">
                                    <div className="img-box">
                                        <img
                                            src={URL.createObjectURL(
                                                thumbnail.file
                                            )}
                                            alt="Thumbnail preview"
                                            className="thumbnail-preview"
                                            style={{
                                                height: '150px',
                                                width: '150px',
                                                objectFit: 'cover',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc'
                                            }}
                                        />
                                        <i
                                            className="fas fa-times icon-x"
                                            onClick={() => setThumbnail(null)}
                                        ></i>
                                    </div>
                                </div>
                            )}
                        </div>
                        {thumbnail?.isErr && (
                            <span className="text-red-primary text-12 mg-t-10">
                            ファイルのアップロードに失敗しました。ファイルサイズが上限の
                                {formatBytes(THUMBNAIL_MAX_SIZE)}
                            を超えています。再度お試しください。
                            </span>
                        )}
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="cancel" onClick={hide}>
                    キャンセル
                    </button>
                    <button
                        className="btn btn-submit"
                        disabled={!video || video.isErr || thumbnail?.isErr}
                        onClick={onSubmit}
                    >
                    保存
                    </button>
                </div>
            </div>
            {
                isShowProgressUpload && (
                    <Modal
                        isOpen={true}
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',
                                transform: 'translate(-50%, -50%)'
                            }
                        }}
                    >
                        <div className='modal-content modal-video-uploading'>
                            <div className='modal-header'>
                                <h4 className='modal-title'>{MSG['msg.upload_video_title']}</h4>
                            </div>

                            <div className='modal-video-body'>
                                <p>{MSG['msg.upload_video_desc']}</p>
                                <div className="progress">
                                    <div className="progress-bar"
                                        role="progressbar"
                                        aria-label="Video uploading"
                                        style={{ width: progress + '%' }} aria-valuenow={progress}
                                        aria-valuemin="0" aria-valuemax="100">{progress}%</div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                )
            }
        </>
    );
};

export default ModalUploadVideo;
